import { Environment } from './environment-interface';

export const environment: Environment = {
	name: 'development',
	enableLogging: true,
	cognito: {
		userPoolId: 'eu-west-1_Vxr6fNbES',
		userPoolClientId: '1bt1svuk3mn53h501m06kd7dd4',
		identityPoolId: 'eu-west-1:d7155415-c7b9-400f-9bd2-7a9eb23b7307',
	},
	api: 'https://wmonkcjf63.execute-api.eu-west-1.amazonaws.com/dev'
};

